var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowP(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2666_2580)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5456 26.0179C45.5781 25.8674 45.4355 25.7382 45.2889 25.7852L41.8257 26.8969C41.6791 26.944 41.6384 27.1321 41.7525 27.2355L42.6402 28.0405C42.2114 28.275 41.9334 28.6176 41.7371 28.962C41.5664 29.2613 41.4365 29.604 41.3285 29.889C41.3101 29.9374 41.2924 29.9842 41.2752 30.0288C41.0181 30.696 40.7865 31.1494 40.2206 31.4154C39.9648 31.5358 39.6266 31.5272 39.0876 31.2839C38.584 31.0566 38.0478 30.6912 37.4276 30.2686L37.4275 30.2686L37.2647 30.1577C36.6097 29.7122 35.8631 29.2159 35.0941 28.9241C34.3058 28.6249 33.41 28.5087 32.5116 28.9311C31.597 29.3612 31.1179 30.1756 30.8532 31.0103C30.5918 31.8347 30.506 32.7831 30.4479 33.6344C30.4368 33.796 30.4268 33.9535 30.417 34.107V34.107C30.3726 34.8017 30.3338 35.4111 30.2337 35.9211C30.1048 36.5781 29.9281 36.7599 29.8247 36.8086C29.4601 36.98 29.2008 37.0186 28.9976 37.015C28.7782 37.0111 28.58 36.9594 28.2886 36.8772L28.2577 36.8684L28.2577 36.8684C27.9876 36.792 27.628 36.6903 27.2113 36.6799C26.7601 36.6687 26.2797 36.7626 25.7354 37.0185C24.5546 37.5737 23.9475 38.7756 23.6355 39.6722C23.4726 40.1404 23.3728 40.5757 23.3135 40.893C23.2836 41.0524 23.2637 41.184 23.251 41.2777C23.2446 41.3246 23.2401 41.3621 23.237 41.389L23.2335 41.4212L23.2325 41.431L23.2321 41.4343L23.232 41.4356L23.232 41.4361C23.232 41.4363 23.2319 41.4366 23.9408 41.504L23.2319 41.4366C23.1927 41.8489 23.4952 42.215 23.9076 42.2542C24.3198 42.2934 24.6858 41.9911 24.7252 41.5789L24.7252 41.5785L24.7254 41.5769L24.7273 41.5591C24.7293 41.5421 24.7325 41.515 24.7374 41.4791C24.7471 41.4073 24.7632 41.3006 24.7879 41.1687C24.8375 40.9032 24.9203 40.5441 25.0522 40.1652C25.3297 39.3675 25.7605 38.6642 26.3737 38.3759C26.7262 38.2101 26.9764 38.1746 27.174 38.1795C27.3899 38.1848 27.5853 38.2373 27.8812 38.3208L27.8982 38.3256C28.1205 38.3883 28.4019 38.4678 28.7278 38.5003C28.8063 38.5082 28.8875 38.5133 28.971 38.5147C29.4259 38.5228 29.9116 38.4253 30.463 38.166C31.2755 37.7839 31.5665 36.9191 31.7057 36.2099C31.8265 35.5941 31.8727 34.8609 31.9167 34.1642C31.9258 34.0196 31.9348 33.8766 31.9444 33.7366C32.0029 32.8795 32.0824 32.0967 32.2831 31.4637C32.4805 30.8409 32.7603 30.4718 33.1499 30.2886C33.5558 30.0977 34.0022 30.1141 34.562 30.3265C35.1411 30.5462 35.7485 30.9405 36.4212 31.398L36.6021 31.5214C37.1925 31.9245 37.8397 32.3664 38.4705 32.6511C39.1744 32.9688 40.0208 33.167 40.8589 32.7729C41.9975 32.2375 42.4045 31.2697 42.6749 30.5682C42.6975 30.5094 42.7189 30.4535 42.7392 30.4001C42.8498 30.1102 42.9323 29.8942 43.0401 29.705C43.1539 29.5055 43.2625 29.4011 43.396 29.3383C43.5423 29.2695 43.656 29.1595 43.7298 29.0287L44.4468 29.6789C44.5609 29.7823 44.7441 29.7235 44.7767 29.573L45.5456 26.0179Z",
    fill: "url(#paint0_linear_2666_2580)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2666_2580",
    x: -23.7127,
    y: -2.63194,
    width: 116.204,
    height: 110.365,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18.5339
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.4706
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.411765 0 0 0 0 0.407843 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2666_2580"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2666_2580",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2666_2580",
    x1: 34.3894,
    y1: 52.3118,
    x2: 18.2142,
    y2: 9.30045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF006D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB7F5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowP);
export default __webpack_public_path__ + "static/media/arrow-p.3fb1221447fe4348fc180c7eec3e5e77.svg";
export { ForwardRef as ReactComponent };